import React from 'react';

import { ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { TableOfContentsContainer as TableOfContentsContainerComponent } from 'src/components/TableOfContentsContainer';
import { ScrollLinkWrapper } from '@ads-core/components';

type ExtendedComponentParams = {
  [key: string]: string | ((...args: string[]) => void) | undefined;
  anchor?: string;
};
export type TableOfContentItem = {
  title: string;
  anchorId: string;
  isActive: boolean;
};

export interface TableOfContentsContainerProps {
  rendering: ComponentRendering;
  params?: ExtendedComponentParams;
}

const TableOfContentsContainer = (props: TableOfContentsContainerProps) => {
  return (
    <ScrollLinkWrapper anchorId={props.params?.anchor}>
      <TableOfContentsContainerComponent {...props} />
    </ScrollLinkWrapper>
  );
};

export default TableOfContentsContainer;
